import { API_URL_COUNTRIES } from "../config/env";

export async function fetchCountryData() {
	try {
		const response = await fetch(API_URL_COUNTRIES);
		if (!response.ok) {
			throw new Error(`HTTP error! Status: ${response.status}`);
		}

		const json = await response.json();

		return json ?? [];
	} catch (error) {
		console.error("Error fetching trade data:", error);
		return [];
	}
}